import { Minute } from '@nu-art/ts-common';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_DataMigration = {
    _v1: {
        preview: { method: HttpMethod.POST, path: '/v1/data-migration/preview', timeout: Minute },
        dryRun: { method: HttpMethod.POST, path: '/v1/data-migration/dry-run', timeout: 2 * Minute },
        execute: { method: HttpMethod.POST, path: '/v1/data-migration/execute', timeout: 5 * Minute },
    }
};
//# sourceMappingURL=apis.js.map